import React, { FC } from 'react'

import clsx from 'clsx';

import SortTriangle from './sortTriangle';

import styles from './sortIcon.module.scss'

interface I_SortIcon {
  state?: {column: string, direction: string};
  target?: string;
}

const SortIcon: FC<I_SortIcon> = ({ state, target }) => {

  const styleTriangle =
  !state || state.direction === 'none'
      ? ''
      : state.column !== target
      ? ''
      : state.direction === 'up'
      ? 'up'
      : state.direction === 'down'
      ? 'down'
      : '';

  return (
    <div className={clsx(styles.main, styles[styleTriangle])}>
      <SortTriangle />
    </div>
  )
}

export default SortIcon